import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ICONS } from 'src/app/core/constants/icons';
import { ROUTES } from 'src/app/core/constants/routes';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss']
})
export class MaintenanceComponent {
  LOGO = ICONS.LOGO;

  constructor(private router: Router) {}

  navigateToHomePage() {
    this.router.navigate([ROUTES.BETTING_TASKS]);
  }
}
